/* eslint-disable */

import _IconAchtungYellow from "@images/sprite/ph_achtung_yellow.svg";
export const IconAchtungYellow: string = _IconAchtungYellow;

import _IconAirConditioningBlack from "@images/sprite/ph_air-conditioning_black.svg";
export const IconAirConditioningBlack: string = _IconAirConditioningBlack;

import _IconAlignTop from "@images/sprite/ph_align-top.svg";
export const IconAlignTop: string = _IconAlignTop;

import _IconAntDesignEditFilledBlue from "@images/sprite/ph_ant-design-edit-filled_blue.svg";
export const IconAntDesignEditFilledBlue: string = _IconAntDesignEditFilledBlue;

import _IconApprovalGreen from "@images/sprite/ph_approval_green.svg";
export const IconApprovalGreen: string = _IconApprovalGreen;

import _IconArchiveBoxFillBigBlue from "@images/sprite/ph_archive-box-fill-big_blue.svg";
export const IconArchiveBoxFillBigBlue: string = _IconArchiveBoxFillBigBlue;

import _IconArchive from "@images/sprite/ph_archive.svg";
export const IconArchive: string = _IconArchive;

import _IconArrowClockwiseFill from "@images/sprite/ph_arrow-clockwise-fill.svg";
export const IconArrowClockwiseFill: string = _IconArrowClockwiseFill;

import _IconArrowClockwiseFillBlue from "@images/sprite/ph_arrow-clockwise-fill_blue.svg";
export const IconArrowClockwiseFillBlue: string = _IconArrowClockwiseFillBlue;

import _IconArrowCounterClockwiseFillBigBlue from "@images/sprite/ph_arrow-counter-clockwise-fill-big_blue.svg";
export const IconArrowCounterClockwiseFillBigBlue: string = _IconArrowCounterClockwiseFillBigBlue;

import _IconArrowCounterClockwiseFillBlack from "@images/sprite/ph_arrow-counter-clockwise-fill_black.svg";
export const IconArrowCounterClockwiseFillBlack: string = _IconArrowCounterClockwiseFillBlack;

import _IconArrowCounterClockwiseFillBlue from "@images/sprite/ph_arrow-counter-clockwise-fill_blue.svg";
export const IconArrowCounterClockwiseFillBlue: string = _IconArrowCounterClockwiseFillBlue;

import _IconArrowDownGray from "@images/sprite/ph_arrow-down_gray.svg";
export const IconArrowDownGray: string = _IconArrowDownGray;

import _IconArrowLeftSmallGray from "@images/sprite/ph_arrow-left-small_gray.svg";
export const IconArrowLeftSmallGray: string = _IconArrowLeftSmallGray;

import _IconArrowLeft from "@images/sprite/ph_arrow-left.svg";
export const IconArrowLeft: string = _IconArrowLeft;

import _IconArrowLeftBlack from "@images/sprite/ph_arrow-left_black.svg";
export const IconArrowLeftBlack: string = _IconArrowLeftBlack;

import _IconArrowMenuGray from "@images/sprite/ph_arrow-menu_gray.svg";
export const IconArrowMenuGray: string = _IconArrowMenuGray;

import _IconArrowMenuWhite from "@images/sprite/ph_arrow-menu_white.svg";
export const IconArrowMenuWhite: string = _IconArrowMenuWhite;

import _IconArrowRightAltGray from "@images/sprite/ph_arrow-right-alt_gray.svg";
export const IconArrowRightAltGray: string = _IconArrowRightAltGray;

import _IconArrowRightSmall from "@images/sprite/ph_arrow-right-small.svg";
export const IconArrowRightSmall: string = _IconArrowRightSmall;

import _IconArrowRightSmallBlack from "@images/sprite/ph_arrow-right-small_black.svg";
export const IconArrowRightSmallBlack: string = _IconArrowRightSmallBlack;

import _IconArrowRightSmallBlue from "@images/sprite/ph_arrow-right-small_blue.svg";
export const IconArrowRightSmallBlue: string = _IconArrowRightSmallBlue;

import _IconArrowRightSmallGrayDarker from "@images/sprite/ph_arrow-right-small_gray-darker.svg";
export const IconArrowRightSmallGrayDarker: string = _IconArrowRightSmallGrayDarker;

import _IconArrowRightSmallGray from "@images/sprite/ph_arrow-right-small_gray.svg";
export const IconArrowRightSmallGray: string = _IconArrowRightSmallGray;

import _IconArrowRight from "@images/sprite/ph_arrow-right.svg";
export const IconArrowRight: string = _IconArrowRight;

import _IconArrowRightBlue from "@images/sprite/ph_arrow-right_blue.svg";
export const IconArrowRightBlue: string = _IconArrowRightBlue;

import _IconArrowRightGrayDark from "@images/sprite/ph_arrow-right_gray-dark.svg";
export const IconArrowRightGrayDark: string = _IconArrowRightGrayDark;

import _IconArrowRightGrayDarker from "@images/sprite/ph_arrow-right_gray-darker.svg";
export const IconArrowRightGrayDarker: string = _IconArrowRightGrayDarker;

import _IconArrowRightWhite from "@images/sprite/ph_arrow-right_white.svg";
export const IconArrowRightWhite: string = _IconArrowRightWhite;

import _IconArrowSquareOut from "@images/sprite/ph_arrow-square-out.svg";
export const IconArrowSquareOut: string = _IconArrowSquareOut;

import _IconArrowSquareOutBlack from "@images/sprite/ph_arrow-square-out_black.svg";
export const IconArrowSquareOutBlack: string = _IconArrowSquareOutBlack;

import _IconArrowSquareOutWhite from "@images/sprite/ph_arrow-square-out_white.svg";
export const IconArrowSquareOutWhite: string = _IconArrowSquareOutWhite;

import _IconArrowUpDown from "@images/sprite/ph_arrow-up-down.svg";
export const IconArrowUpDown: string = _IconArrowUpDown;

import _IconArrowsLeftRight from "@images/sprite/ph_arrows-left-right.svg";
export const IconArrowsLeftRight: string = _IconArrowsLeftRight;

import _IconArrowsOutCardinalBlack from "@images/sprite/ph_arrows-out-cardinal-black.svg";
export const IconArrowsOutCardinalBlack: string = _IconArrowsOutCardinalBlack;

import _IconArrowsOutCardinalGray from "@images/sprite/ph_arrows-out-cardinal_gray.svg";
export const IconArrowsOutCardinalGray: string = _IconArrowsOutCardinalGray;

import _IconArrowsOutCardinalWhite from "@images/sprite/ph_arrows-out-cardinal_white.svg";
export const IconArrowsOutCardinalWhite: string = _IconArrowsOutCardinalWhite;

import _IconArrowsOutFillBlack from "@images/sprite/ph_arrows-out-fill_black.svg";
export const IconArrowsOutFillBlack: string = _IconArrowsOutFillBlack;

import _IconBarbell from "@images/sprite/ph_barbell.svg";
export const IconBarbell: string = _IconBarbell;

import _IconBellRingingFill from "@images/sprite/ph_bell-ringing-fill.svg";
export const IconBellRingingFill: string = _IconBellRingingFill;

import _IconBellRinging from "@images/sprite/ph_bell-ringing.svg";
export const IconBellRinging: string = _IconBellRinging;

import _IconBicycle from "@images/sprite/ph_bicycle.svg";
export const IconBicycle: string = _IconBicycle;

import _IconBicycleGrayDarker from "@images/sprite/ph_bicycle_gray-darker.svg";
export const IconBicycleGrayDarker: string = _IconBicycleGrayDarker;

import _IconBookBookmarkBigGreen from "@images/sprite/ph_book-bookmark-big_green.svg";
export const IconBookBookmarkBigGreen: string = _IconBookBookmarkBigGreen;

import _IconBookmarkSimpleFillSmallBlue from "@images/sprite/ph_bookmark-simple-fill-small_blue.svg";
export const IconBookmarkSimpleFillSmallBlue: string = _IconBookmarkSimpleFillSmallBlue;

import _IconBookmarkSimpleFill from "@images/sprite/ph_bookmark-simple-fill.svg";
export const IconBookmarkSimpleFill: string = _IconBookmarkSimpleFill;

import _IconBookmarkSimpleFillBlue from "@images/sprite/ph_bookmark-simple-fill_blue.svg";
export const IconBookmarkSimpleFillBlue: string = _IconBookmarkSimpleFillBlue;

import _IconBookmarkSimpleBlack from "@images/sprite/ph_bookmark-simple_black.svg";
export const IconBookmarkSimpleBlack: string = _IconBookmarkSimpleBlack;

import _IconBookmarkSimpleBlue from "@images/sprite/ph_bookmark-simple_blue.svg";
export const IconBookmarkSimpleBlue: string = _IconBookmarkSimpleBlue;

import _IconBookmarkSimpleSmall from "@images/sprite/ph_bookmark-simple_small.svg";
export const IconBookmarkSimpleSmall: string = _IconBookmarkSimpleSmall;

import _IconBriefcase from "@images/sprite/ph_briefcase.svg";
export const IconBriefcase: string = _IconBriefcase;

import _IconBroom from "@images/sprite/ph_broom.svg";
export const IconBroom: string = _IconBroom;

import _IconBuildingsFill from "@images/sprite/ph_buildings-fill.svg";
export const IconBuildingsFill: string = _IconBuildingsFill;

import _IconBuildingsFillBlue from "@images/sprite/ph_buildings-fill_blue.svg";
export const IconBuildingsFillBlue: string = _IconBuildingsFillBlue;

import _IconBuildingsSmallGray from "@images/sprite/ph_buildings-small_gray.svg";
export const IconBuildingsSmallGray: string = _IconBuildingsSmallGray;

import _IconBuildings from "@images/sprite/ph_buildings.svg";
export const IconBuildings: string = _IconBuildings;

import _IconBuildingsMagic from "@images/sprite/ph_buildings_magic.svg";
export const IconBuildingsMagic: string = _IconBuildingsMagic;

import _IconCafeteriaBlack from "@images/sprite/ph_cafeteria_black.svg";
export const IconCafeteriaBlack: string = _IconCafeteriaBlack;

import _IconCalendarBlankFillAltBlack from "@images/sprite/ph_calendar-blank-fill-alt_black.svg";
export const IconCalendarBlankFillAltBlack: string = _IconCalendarBlankFillAltBlack;

import _IconCalendarBlankFillMediumWhite from "@images/sprite/ph_calendar-blank-fill-medium_white.svg";
export const IconCalendarBlankFillMediumWhite: string = _IconCalendarBlankFillMediumWhite;

import _IconCalendarBlankFill from "@images/sprite/ph_calendar-blank-fill.svg";
export const IconCalendarBlankFill: string = _IconCalendarBlankFill;

import _IconCalendarBlankFillBlack from "@images/sprite/ph_calendar-blank-fill_black.svg";
export const IconCalendarBlankFillBlack: string = _IconCalendarBlankFillBlack;

import _IconCalendarBlankFillBlue from "@images/sprite/ph_calendar-blank-fill_blue.svg";
export const IconCalendarBlankFillBlue: string = _IconCalendarBlankFillBlue;

import _IconCalendarBlankFillGrayDarker from "@images/sprite/ph_calendar-blank-fill_gray-darker.svg";
export const IconCalendarBlankFillGrayDarker: string = _IconCalendarBlankFillGrayDarker;

import _IconCalendarPlus from "@images/sprite/ph_calendar-plus.svg";
export const IconCalendarPlus: string = _IconCalendarPlus;

import _IconCallBell from "@images/sprite/ph_call-bell.svg";
export const IconCallBell: string = _IconCallBell;

import _IconCameraFillBlack from "@images/sprite/ph_camera-fill_black.svg";
export const IconCameraFillBlack: string = _IconCameraFillBlack;

import _IconCameraOutline from "@images/sprite/ph_camera-outline.svg";
export const IconCameraOutline: string = _IconCameraOutline;

import _IconCaretDownFill from "@images/sprite/ph_caret-down-fill.svg";
export const IconCaretDownFill: string = _IconCaretDownFill;

import _IconCaretDownFillBlueDark from "@images/sprite/ph_caret-down-fill_blue-dark.svg";
export const IconCaretDownFillBlueDark: string = _IconCaretDownFillBlueDark;

import _IconCaretDownFillBlue from "@images/sprite/ph_caret-down-fill_blue.svg";
export const IconCaretDownFillBlue: string = _IconCaretDownFillBlue;

import _IconCaretDownFillRed from "@images/sprite/ph_caret-down-fill_red.svg";
export const IconCaretDownFillRed: string = _IconCaretDownFillRed;

import _IconCaretDownSmall from "@images/sprite/ph_caret-down-small.svg";
export const IconCaretDownSmall: string = _IconCaretDownSmall;

import _IconCaretDownSmallBlueDark from "@images/sprite/ph_caret-down-small_blue-dark.svg";
export const IconCaretDownSmallBlueDark: string = _IconCaretDownSmallBlueDark;

import _IconCaretDownSmallBlue from "@images/sprite/ph_caret-down-small_blue.svg";
export const IconCaretDownSmallBlue: string = _IconCaretDownSmallBlue;

import _IconCaretDownSmallGrayDark from "@images/sprite/ph_caret-down-small_gray-dark.svg";
export const IconCaretDownSmallGrayDark: string = _IconCaretDownSmallGrayDark;

import _IconCaretDown from "@images/sprite/ph_caret-down.svg";
export const IconCaretDown: string = _IconCaretDown;

import _IconCaretDownBlack from "@images/sprite/ph_caret-down_black.svg";
export const IconCaretDownBlack: string = _IconCaretDownBlack;

import _IconCaretDownBlue from "@images/sprite/ph_caret-down_blue.svg";
export const IconCaretDownBlue: string = _IconCaretDownBlue;

import _IconCaretDownGrayDark from "@images/sprite/ph_caret-down_gray-dark.svg";
export const IconCaretDownGrayDark: string = _IconCaretDownGrayDark;

import _IconCaretDownWhite from "@images/sprite/ph_caret-down_white.svg";
export const IconCaretDownWhite: string = _IconCaretDownWhite;

import _IconCaretLeft from "@images/sprite/ph_caret-left.svg";
export const IconCaretLeft: string = _IconCaretLeft;

import _IconCaretLeftBlack from "@images/sprite/ph_caret-left_black.svg";
export const IconCaretLeftBlack: string = _IconCaretLeftBlack;

import _IconCaretLeftGrayDark from "@images/sprite/ph_caret-left_gray-dark.svg";
export const IconCaretLeftGrayDark: string = _IconCaretLeftGrayDark;

import _IconCaretLeftGray from "@images/sprite/ph_caret-left_gray.svg";
export const IconCaretLeftGray: string = _IconCaretLeftGray;

import _IconCaretLeftWhite from "@images/sprite/ph_caret-left_white.svg";
export const IconCaretLeftWhite: string = _IconCaretLeftWhite;

import _IconCaretRightFillWhite from "@images/sprite/ph_caret-right-fill_white.svg";
export const IconCaretRightFillWhite: string = _IconCaretRightFillWhite;

import _IconCaretRight from "@images/sprite/ph_caret-right.svg";
export const IconCaretRight: string = _IconCaretRight;

import _IconCaretRightBlack from "@images/sprite/ph_caret-right_black.svg";
export const IconCaretRightBlack: string = _IconCaretRightBlack;

import _IconCaretRightBlue from "@images/sprite/ph_caret-right_blue.svg";
export const IconCaretRightBlue: string = _IconCaretRightBlue;

import _IconCaretRightWhite from "@images/sprite/ph_caret-right_white.svg";
export const IconCaretRightWhite: string = _IconCaretRightWhite;

import _IconCaretUpDownBold from "@images/sprite/ph_caret-up-down-bold.svg";
export const IconCaretUpDownBold: string = _IconCaretUpDownBold;

import _IconCaretUpFillBlueDark from "@images/sprite/ph_caret-up-fill_blue-dark.svg";
export const IconCaretUpFillBlueDark: string = _IconCaretUpFillBlueDark;

import _IconCaretUpFillBlue from "@images/sprite/ph_caret-up-fill_blue.svg";
export const IconCaretUpFillBlue: string = _IconCaretUpFillBlue;

import _IconCaretUpFillGreen from "@images/sprite/ph_caret-up-fill_green.svg";
export const IconCaretUpFillGreen: string = _IconCaretUpFillGreen;

import _IconCaretUpSmall from "@images/sprite/ph_caret-up-small.svg";
export const IconCaretUpSmall: string = _IconCaretUpSmall;

import _IconCaretUpSmallBlueDark from "@images/sprite/ph_caret-up-small_blue-dark.svg";
export const IconCaretUpSmallBlueDark: string = _IconCaretUpSmallBlueDark;

import _IconCaretUpBlack from "@images/sprite/ph_caret-up_black.svg";
export const IconCaretUpBlack: string = _IconCaretUpBlack;

import _IconChair from "@images/sprite/ph_chair.svg";
export const IconChair: string = _IconChair;

import _IconChair2 from "@images/sprite/ph_chair_2.svg";
export const IconChair2: string = _IconChair2;

import _IconChairFill from "@images/sprite/ph_chair_fill.svg";
export const IconChairFill: string = _IconChairFill;

import _IconChartBlue from "@images/sprite/ph_chart_blue.svg";
export const IconChartBlue: string = _IconChartBlue;

import _IconChatTextFillBlue from "@images/sprite/ph_chat-text-fill_blue.svg";
export const IconChatTextFillBlue: string = _IconChatTextFillBlue;

import _IconChatText from "@images/sprite/ph_chat-text.svg";
export const IconChatText: string = _IconChatText;

import _IconChatTextGrayDarker from "@images/sprite/ph_chat-text_gray-darker.svg";
export const IconChatTextGrayDarker: string = _IconChatTextGrayDarker;

import _IconChatsFill from "@images/sprite/ph_chats-fill.svg";
export const IconChatsFill: string = _IconChatsFill;

import _IconChatsFillBlue from "@images/sprite/ph_chats-fill_blue.svg";
export const IconChatsFillBlue: string = _IconChatsFillBlue;

import _IconChatsFillGray from "@images/sprite/ph_chats-fill_gray.svg";
export const IconChatsFillGray: string = _IconChatsFillGray;

import _IconChatsFillWhite from "@images/sprite/ph_chats-fill_white.svg";
export const IconChatsFillWhite: string = _IconChatsFillWhite;

import _IconCheckAlt from "@images/sprite/ph_check-alt.svg";
export const IconCheckAlt: string = _IconCheckAlt;

import _IconCheckBigWhite from "@images/sprite/ph_check-big_white.svg";
export const IconCheckBigWhite: string = _IconCheckBigWhite;

import _IconCheckBlue from "@images/sprite/ph_check-blue.svg";
export const IconCheckBlue: string = _IconCheckBlue;

import _IconCheckBoldBlue from "@images/sprite/ph_check-bold_blue.svg";
export const IconCheckBoldBlue: string = _IconCheckBoldBlue;

import _IconCheckBoldGreen from "@images/sprite/ph_check-bold_green.svg";
export const IconCheckBoldGreen: string = _IconCheckBoldGreen;

import _IconCheckCircleFillAltGreen from "@images/sprite/ph_check-circle-fill-alt_green.svg";
export const IconCheckCircleFillAltGreen: string = _IconCheckCircleFillAltGreen;

import _IconCheckCircleFillBigGreen from "@images/sprite/ph_check-circle-fill-big_green.svg";
export const IconCheckCircleFillBigGreen: string = _IconCheckCircleFillBigGreen;

import _IconCheckCircleFillBiggerGreen from "@images/sprite/ph_check-circle-fill-bigger_green.svg";
export const IconCheckCircleFillBiggerGreen: string = _IconCheckCircleFillBiggerGreen;

import _IconCheckCircleFillMediumGreen from "@images/sprite/ph_check-circle-fill-medium_green.svg";
export const IconCheckCircleFillMediumGreen: string = _IconCheckCircleFillMediumGreen;

import _IconCheckCircleFillSmallGreen from "@images/sprite/ph_check-circle-fill-small_green.svg";
export const IconCheckCircleFillSmallGreen: string = _IconCheckCircleFillSmallGreen;

import _IconCheckCircleFillSmallerGreen from "@images/sprite/ph_check-circle-fill-smaller_green.svg";
export const IconCheckCircleFillSmallerGreen: string = _IconCheckCircleFillSmallerGreen;

import _IconCheckCircleFill from "@images/sprite/ph_check-circle-fill.svg";
export const IconCheckCircleFill: string = _IconCheckCircleFill;

import _IconCheckCircleFillGray from "@images/sprite/ph_check-circle-fill_gray.svg";
export const IconCheckCircleFillGray: string = _IconCheckCircleFillGray;

import _IconCheckCircleFillGreen from "@images/sprite/ph_check-circle-fill_green.svg";
export const IconCheckCircleFillGreen: string = _IconCheckCircleFillGreen;

import _IconCheckCircleFillRed from "@images/sprite/ph_check-circle-fill_red.svg";
export const IconCheckCircleFillRed: string = _IconCheckCircleFillRed;

import _IconCheckCircleFillWhite from "@images/sprite/ph_check-circle-fill_white.svg";
export const IconCheckCircleFillWhite: string = _IconCheckCircleFillWhite;

import _IconCheckCircleBlack from "@images/sprite/ph_check-circle_black.svg";
export const IconCheckCircleBlack: string = _IconCheckCircleBlack;

import _IconCheckCircleBlue from "@images/sprite/ph_check-circle_blue.svg";
export const IconCheckCircleBlue: string = _IconCheckCircleBlue;

import _IconCheckCircleGreen from "@images/sprite/ph_check-circle_green.svg";
export const IconCheckCircleGreen: string = _IconCheckCircleGreen;

import _IconCheckThinLittleGray from "@images/sprite/ph_check-thin-little_gray.svg";
export const IconCheckThinLittleGray: string = _IconCheckThinLittleGray;

import _IconCheckThinSmallBlack from "@images/sprite/ph_check-thin-small_black.svg";
export const IconCheckThinSmallBlack: string = _IconCheckThinSmallBlack;

import _IconCheckThinSmallGrayDarker from "@images/sprite/ph_check-thin-small_gray-darker.svg";
export const IconCheckThinSmallGrayDarker: string = _IconCheckThinSmallGrayDarker;

import _IconCheckThinBlack from "@images/sprite/ph_check-thin_black.svg";
export const IconCheckThinBlack: string = _IconCheckThinBlack;

import _IconCheckThinGray from "@images/sprite/ph_check-thin_gray.svg";
export const IconCheckThinGray: string = _IconCheckThinGray;

import _IconCheckThinWhite from "@images/sprite/ph_check-thin_white.svg";
export const IconCheckThinWhite: string = _IconCheckThinWhite;

import _IconCheck from "@images/sprite/ph_check.svg";
export const IconCheck: string = _IconCheck;

import _IconCheckGreen from "@images/sprite/ph_check_green.svg";
export const IconCheckGreen: string = _IconCheckGreen;

import _IconCheckWhite from "@images/sprite/ph_check_white.svg";
export const IconCheckWhite: string = _IconCheckWhite;

import _IconChefHat from "@images/sprite/ph_chef-hat.svg";
export const IconChefHat: string = _IconChefHat;

import _IconCircleBicolorLeftWhite from "@images/sprite/ph_circle-bicolor-left_white.svg";
export const IconCircleBicolorLeftWhite: string = _IconCircleBicolorLeftWhite;

import _IconCircleBicolorRightWhite from "@images/sprite/ph_circle-bicolor-right_white.svg";
export const IconCircleBicolorRightWhite: string = _IconCircleBicolorRightWhite;

import _IconCircleFillSmallBlack from "@images/sprite/ph_circle-fill-small_black.svg";
export const IconCircleFillSmallBlack: string = _IconCircleFillSmallBlack;

import _IconCircleFillSmallBlue from "@images/sprite/ph_circle-fill-small_blue.svg";
export const IconCircleFillSmallBlue: string = _IconCircleFillSmallBlue;

import _IconCircleFillSmallGreen from "@images/sprite/ph_circle-fill-small_green.svg";
export const IconCircleFillSmallGreen: string = _IconCircleFillSmallGreen;

import _IconCircleFillSmallRed from "@images/sprite/ph_circle-fill-small_red.svg";
export const IconCircleFillSmallRed: string = _IconCircleFillSmallRed;

import _IconCircleFill from "@images/sprite/ph_circle-fill.svg";
export const IconCircleFill: string = _IconCircleFill;

import _IconCircleFillBlack from "@images/sprite/ph_circle-fill_black.svg";
export const IconCircleFillBlack: string = _IconCircleFillBlack;

import _IconCircleFillGrayDark from "@images/sprite/ph_circle-fill_gray-dark.svg";
export const IconCircleFillGrayDark: string = _IconCircleFillGrayDark;

import _IconCircleFillGrayDarker from "@images/sprite/ph_circle-fill_gray-darker.svg";
export const IconCircleFillGrayDarker: string = _IconCircleFillGrayDarker;

import _IconCircleFillGray from "@images/sprite/ph_circle-fill_gray.svg";
export const IconCircleFillGray: string = _IconCircleFillGray;

import _IconCircleFillGreen from "@images/sprite/ph_circle-fill_green.svg";
export const IconCircleFillGreen: string = _IconCircleFillGreen;

import _IconCircleGray from "@images/sprite/ph_circle_gray.svg";
export const IconCircleGray: string = _IconCircleGray;

import _IconCircleGreen from "@images/sprite/ph_circle_green.svg";
export const IconCircleGreen: string = _IconCircleGreen;

import _IconCleaning from "@images/sprite/ph_cleaning.svg";
export const IconCleaning: string = _IconCleaning;

import _IconClockClockwiseReverse from "@images/sprite/ph_clock-clockwise-reverse.svg";
export const IconClockClockwiseReverse: string = _IconClockClockwiseReverse;

import _IconClockClockwiseSmallGray from "@images/sprite/ph_clock-clockwise-small_gray.svg";
export const IconClockClockwiseSmallGray: string = _IconClockClockwiseSmallGray;

import _IconClockClockwise from "@images/sprite/ph_clock-clockwise.svg";
export const IconClockClockwise: string = _IconClockClockwise;

import _IconClockClockwiseBlack from "@images/sprite/ph_clock-clockwise_black.svg";
export const IconClockClockwiseBlack: string = _IconClockClockwiseBlack;

import _IconCloseSquaredGray from "@images/sprite/ph_close-squared_gray.svg";
export const IconCloseSquaredGray: string = _IconCloseSquaredGray;

import _IconCoffeeFillBlue from "@images/sprite/ph_coffee-fill_blue.svg";
export const IconCoffeeFillBlue: string = _IconCoffeeFillBlue;

import _IconCoinsBigBlack from "@images/sprite/ph_coins-big_black.svg";
export const IconCoinsBigBlack: string = _IconCoinsBigBlack;

import _IconCoins from "@images/sprite/ph_coins.svg";
export const IconCoins: string = _IconCoins;

import _IconCoinsBlack from "@images/sprite/ph_coins_black.svg";
export const IconCoinsBlack: string = _IconCoinsBlack;

import _IconCoinsBlue from "@images/sprite/ph_coins_blue.svg";
export const IconCoinsBlue: string = _IconCoinsBlue;

import _IconContactBlue from "@images/sprite/ph_contact_blue.svg";
export const IconContactBlue: string = _IconContactBlue;

import _IconContactedGreen from "@images/sprite/ph_contacted_green.svg";
export const IconContactedGreen: string = _IconContactedGreen;

import _IconCrosshairFill from "@images/sprite/ph_crosshair-fill.svg";
export const IconCrosshairFill: string = _IconCrosshairFill;

import _IconDedicatedNetwork from "@images/sprite/ph_dedicated-network.svg";
export const IconDedicatedNetwork: string = _IconDedicatedNetwork;

import _IconDesktopTowerFillBlue from "@images/sprite/ph_desktop-tower-fill_blue.svg";
export const IconDesktopTowerFillBlue: string = _IconDesktopTowerFillBlue;

import _IconDiamondFourFillWhite from "@images/sprite/ph_diamond-four-fill_white.svg";
export const IconDiamondFourFillWhite: string = _IconDiamondFourFillWhite;

import _IconDisabledCheck from "@images/sprite/ph_disabled-check.svg";
export const IconDisabledCheck: string = _IconDisabledCheck;

import _IconDogFill from "@images/sprite/ph_dog-fill.svg";
export const IconDogFill: string = _IconDogFill;

import _IconDoorBold from "@images/sprite/ph_door-bold.svg";
export const IconDoorBold: string = _IconDoorBold;

import _IconDoor from "@images/sprite/ph_door.svg";
export const IconDoor: string = _IconDoor;

import _IconDoorFill from "@images/sprite/ph_door_fill.svg";
export const IconDoorFill: string = _IconDoorFill;

import _IconDotsSixVerticalBig from "@images/sprite/ph_dots-six-vertical-big.svg";
export const IconDotsSixVerticalBig: string = _IconDotsSixVerticalBig;

import _IconDotsThreeBold from "@images/sprite/ph_dots-three-bold.svg";
export const IconDotsThreeBold: string = _IconDotsThreeBold;

import _IconEditFillBlack from "@images/sprite/ph_edit-fill_black.svg";
export const IconEditFillBlack: string = _IconEditFillBlack;

import _IconEditGreen from "@images/sprite/ph_edit_green.svg";
export const IconEditGreen: string = _IconEditGreen;

import _IconEmptyBlack from "@images/sprite/ph_empty_black.svg";
export const IconEmptyBlack: string = _IconEmptyBlack;

import _IconEnvelopeBigBlue from "@images/sprite/ph_envelope-big_blue.svg";
export const IconEnvelopeBigBlue: string = _IconEnvelopeBigBlue;

import _IconEnvelopeOpenFill from "@images/sprite/ph_envelope-open-fill.svg";
export const IconEnvelopeOpenFill: string = _IconEnvelopeOpenFill;

import _IconEnvelopeSmallBlue from "@images/sprite/ph_envelope-small_blue.svg";
export const IconEnvelopeSmallBlue: string = _IconEnvelopeSmallBlue;

import _IconEnvelope from "@images/sprite/ph_envelope.svg";
export const IconEnvelope: string = _IconEnvelope;

import _IconEnvelopeBlack from "@images/sprite/ph_envelope_black.svg";
export const IconEnvelopeBlack: string = _IconEnvelopeBlack;

import _IconEnvelopeBlueDark from "@images/sprite/ph_envelope_blue-dark.svg";
export const IconEnvelopeBlueDark: string = _IconEnvelopeBlueDark;

import _IconEnvelopeBlue from "@images/sprite/ph_envelope_blue.svg";
export const IconEnvelopeBlue: string = _IconEnvelopeBlue;

import _IconEnvelopeGrayDarker from "@images/sprite/ph_envelope_gray-darker.svg";
export const IconEnvelopeGrayDarker: string = _IconEnvelopeGrayDarker;

import _IconEyeballBlack from "@images/sprite/ph_eyeball_black.svg";
export const IconEyeballBlack: string = _IconEyeballBlack;

import _IconEyeballBlue from "@images/sprite/ph_eyeball_blue.svg";
export const IconEyeballBlue: string = _IconEyeballBlue;

import _IconEyeballGreen from "@images/sprite/ph_eyeball_green.svg";
export const IconEyeballGreen: string = _IconEyeballGreen;

import _IconFaviconUbiq from "@images/sprite/ph_favicon-ubiq.svg";
export const IconFaviconUbiq: string = _IconFaviconUbiq;

import _IconFavicon from "@images/sprite/ph_favicon.svg";
export const IconFavicon: string = _IconFavicon;

import _IconFiber from "@images/sprite/ph_fiber.svg";
export const IconFiber: string = _IconFiber;

import _IconFileFill from "@images/sprite/ph_file-fill.svg";
export const IconFileFill: string = _IconFileFill;

import _IconFileFillGray from "@images/sprite/ph_file-fill_gray.svg";
export const IconFileFillGray: string = _IconFileFillGray;

import _IconFile from "@images/sprite/ph_file.svg";
export const IconFile: string = _IconFile;

import _IconFooterFacebook from "@images/sprite/ph_footer-facebook.svg";
export const IconFooterFacebook: string = _IconFooterFacebook;

import _IconFooterInstagram from "@images/sprite/ph_footer-instagram.svg";
export const IconFooterInstagram: string = _IconFooterInstagram;

import _IconFooterLinkedin from "@images/sprite/ph_footer-linkedin.svg";
export const IconFooterLinkedin: string = _IconFooterLinkedin;

import _IconFooterTwitter from "@images/sprite/ph_footer-twitter.svg";
export const IconFooterTwitter: string = _IconFooterTwitter;

import _IconForkKnifePrivate from "@images/sprite/ph_fork-knife-private.svg";
export const IconForkKnifePrivate: string = _IconForkKnifePrivate;

import _IconForkKnife from "@images/sprite/ph_fork-knife.svg";
export const IconForkKnife: string = _IconForkKnife;

import _IconGearSixFill from "@images/sprite/ph_gear-six-fill.svg";
export const IconGearSixFill: string = _IconGearSixFill;

import _IconGlobe from "@images/sprite/ph_globe.svg";
export const IconGlobe: string = _IconGlobe;

import _IconGoogleCalendar from "@images/sprite/ph_google-calendar.svg";
export const IconGoogleCalendar: string = _IconGoogleCalendar;

import _IconGoogleSpreadsheet from "@images/sprite/ph_google-spreadsheet.svg";
export const IconGoogleSpreadsheet: string = _IconGoogleSpreadsheet;

import _IconGoogle from "@images/sprite/ph_google.svg";
export const IconGoogle: string = _IconGoogle;

import _IconGooglemapsMarker from "@images/sprite/ph_googlemaps_marker.svg";
export const IconGooglemapsMarker: string = _IconGooglemapsMarker;

import _IconHeadsetFill from "@images/sprite/ph_headset-fill.svg";
export const IconHeadsetFill: string = _IconHeadsetFill;

import _IconHeartPlusOutline from "@images/sprite/ph_heart-plus-outline.svg";
export const IconHeartPlusOutline: string = _IconHeartPlusOutline;

import _IconHeartStraightBold from "@images/sprite/ph_heart-straight-bold.svg";
export const IconHeartStraightBold: string = _IconHeartStraightBold;

import _IconHeartStraightBoldRed from "@images/sprite/ph_heart-straight-bold_red.svg";
export const IconHeartStraightBoldRed: string = _IconHeartStraightBoldRed;

import _IconHeartStraightFillAltRed from "@images/sprite/ph_heart-straight-fill-alt_red.svg";
export const IconHeartStraightFillAltRed: string = _IconHeartStraightFillAltRed;

import _IconHeartStraightFillSmallRed from "@images/sprite/ph_heart-straight-fill-small_red.svg";
export const IconHeartStraightFillSmallRed: string = _IconHeartStraightFillSmallRed;

import _IconHeartStraightFill from "@images/sprite/ph_heart-straight-fill.svg";
export const IconHeartStraightFill: string = _IconHeartStraightFill;

import _IconHeartStraightFillRed from "@images/sprite/ph_heart-straight-fill_red.svg";
export const IconHeartStraightFillRed: string = _IconHeartStraightFillRed;

import _IconHeartStraightFillWhite from "@images/sprite/ph_heart-straight-fill_white.svg";
export const IconHeartStraightFillWhite: string = _IconHeartStraightFillWhite;

import _IconHeartStraightSmall from "@images/sprite/ph_heart-straight-small.svg";
export const IconHeartStraightSmall: string = _IconHeartStraightSmall;

import _IconHeartStraight from "@images/sprite/ph_heart-straight.svg";
export const IconHeartStraight: string = _IconHeartStraight;

import _IconHeartStraightGrayDarker from "@images/sprite/ph_heart-straight_gray-darker.svg";
export const IconHeartStraightGrayDarker: string = _IconHeartStraightGrayDarker;

import _IconHourglassHighFillBigBlue from "@images/sprite/ph_hourglass-high-fill-big_blue.svg";
export const IconHourglassHighFillBigBlue: string = _IconHourglassHighFillBigBlue;

import _IconHourglassHighFillSmallBlack from "@images/sprite/ph_hourglass-high-fill-small_black.svg";
export const IconHourglassHighFillSmallBlack: string = _IconHourglassHighFillSmallBlack;

import _IconHourglassHighFillBlack from "@images/sprite/ph_hourglass-high-fill_black.svg";
export const IconHourglassHighFillBlack: string = _IconHourglassHighFillBlack;

import _IconHourglassHighFillBlue from "@images/sprite/ph_hourglass-high-fill_blue.svg";
export const IconHourglassHighFillBlue: string = _IconHourglassHighFillBlue;

import _IconHourglassHighFillGrayDarker from "@images/sprite/ph_hourglass-high-fill_gray-darker.svg";
export const IconHourglassHighFillGrayDarker: string = _IconHourglassHighFillGrayDarker;

import _IconHourglassHighFillOrange from "@images/sprite/ph_hourglass-high-fill_orange.svg";
export const IconHourglassHighFillOrange: string = _IconHourglassHighFillOrange;

import _IconHouseLineFillGrayDarker from "@images/sprite/ph_house-line-fill_gray-darker.svg";
export const IconHouseLineFillGrayDarker: string = _IconHouseLineFillGrayDarker;

import _IconHouse from "@images/sprite/ph_house.svg";
export const IconHouse: string = _IconHouse;

import _IconIconInfo from "@images/sprite/ph_icon-info.svg";
export const IconIconInfo: string = _IconIconInfo;

import _IconImageFill from "@images/sprite/ph_image-fill.svg";
export const IconImageFill: string = _IconImageFill;

import _IconInfoFillIconGray from "@images/sprite/ph_info-fill-icon_gray.svg";
export const IconInfoFillIconGray: string = _IconInfoFillIconGray;

import _IconInfoFillSmallGrayDarker from "@images/sprite/ph_info-fill-small_gray-darker.svg";
export const IconInfoFillSmallGrayDarker: string = _IconInfoFillSmallGrayDarker;

import _IconInfoFillSmallGray from "@images/sprite/ph_info-fill-small_gray.svg";
export const IconInfoFillSmallGray: string = _IconInfoFillSmallGray;

import _IconInfoFillSmallWhite from "@images/sprite/ph_info-fill-small_white.svg";
export const IconInfoFillSmallWhite: string = _IconInfoFillSmallWhite;

import _IconInfoFill from "@images/sprite/ph_info-fill.svg";
export const IconInfoFill: string = _IconInfoFill;

import _IconInfoFillBlue from "@images/sprite/ph_info-fill_blue.svg";
export const IconInfoFillBlue: string = _IconInfoFillBlue;

import _IconInfoFillGray from "@images/sprite/ph_info-fill_gray.svg";
export const IconInfoFillGray: string = _IconInfoFillGray;

import _IconInfoFillWhite from "@images/sprite/ph_info-fill_white.svg";
export const IconInfoFillWhite: string = _IconInfoFillWhite;

import _IconKeyFill from "@images/sprite/ph_key-fill.svg";
export const IconKeyFill: string = _IconKeyFill;

import _IconKey from "@images/sprite/ph_key.svg";
export const IconKey: string = _IconKey;

import _IconLetterBox from "@images/sprite/ph_letter-box.svg";
export const IconLetterBox: string = _IconLetterBox;

import _IconLetterCircleP from "@images/sprite/ph_letter-circle-p.svg";
export const IconLetterCircleP: string = _IconLetterCircleP;

import _IconLightbulbFilamentBiggerBlue from "@images/sprite/ph_lightbulb-filament-bigger_blue.svg";
export const IconLightbulbFilamentBiggerBlue: string = _IconLightbulbFilamentBiggerBlue;

import _IconLightbulbFilamentBlack from "@images/sprite/ph_lightbulb-filament_black.svg";
export const IconLightbulbFilamentBlack: string = _IconLightbulbFilamentBlack;

import _IconLightbulbFilamentBlue from "@images/sprite/ph_lightbulb-filament_blue.svg";
export const IconLightbulbFilamentBlue: string = _IconLightbulbFilamentBlue;

import _IconLightbulbFilamentWhite from "@images/sprite/ph_lightbulb-filament_white.svg";
export const IconLightbulbFilamentWhite: string = _IconLightbulbFilamentWhite;

import _IconLightbulbFill from "@images/sprite/ph_lightbulb-fill.svg";
export const IconLightbulbFill: string = _IconLightbulbFill;

import _IconLightbulbFillBlue from "@images/sprite/ph_lightbulb-fill_blue.svg";
export const IconLightbulbFillBlue: string = _IconLightbulbFillBlue;

import _IconLightbulb from "@images/sprite/ph_lightbulb.svg";
export const IconLightbulb: string = _IconLightbulb;

import _IconLightningFillYellow from "@images/sprite/ph_lightning-fill_yellow.svg";
export const IconLightningFillYellow: string = _IconLightningFillYellow;

import _IconLightningGrayDark from "@images/sprite/ph_lightning_gray-dark.svg";
export const IconLightningGrayDark: string = _IconLightningGrayDark;

import _IconLinkSmall from "@images/sprite/ph_link-small.svg";
export const IconLinkSmall: string = _IconLinkSmall;

import _IconLinkBlack from "@images/sprite/ph_link_black.svg";
export const IconLinkBlack: string = _IconLinkBlack;

import _IconLinkBlueDark from "@images/sprite/ph_link_blue-dark.svg";
export const IconLinkBlueDark: string = _IconLinkBlueDark;

import _IconLinkBlue from "@images/sprite/ph_link_blue.svg";
export const IconLinkBlue: string = _IconLinkBlue;

import _IconListBullets from "@images/sprite/ph_list-bullets.svg";
export const IconListBullets: string = _IconListBullets;

import _IconList from "@images/sprite/ph_list.svg";
export const IconList: string = _IconList;

import _IconLocationBlue from "@images/sprite/ph_location_blue.svg";
export const IconLocationBlue: string = _IconLocationBlue;

import _IconLockSimpleFill from "@images/sprite/ph_lock-simple-fill.svg";
export const IconLockSimpleFill: string = _IconLockSimpleFill;

import _IconLock from "@images/sprite/ph_lock.svg";
export const IconLock: string = _IconLock;

import _IconLocker from "@images/sprite/ph_locker.svg";
export const IconLocker: string = _IconLocker;

import _IconLogoAtMail from "@images/sprite/ph_logo-at-mail.svg";
export const IconLogoAtMail: string = _IconLogoAtMail;

import _IconLogoCircle from "@images/sprite/ph_logo-circle.svg";
export const IconLogoCircle: string = _IconLogoCircle;

import _IconLogoSquare from "@images/sprite/ph_logo-square.svg";
export const IconLogoSquare: string = _IconLogoSquare;

import _IconLogo from "@images/sprite/ph_logo.svg";
export const IconLogo: string = _IconLogo;

import _IconMagnifyingGlassWhite from "@images/sprite/ph_magnifying-glass-white.svg";
export const IconMagnifyingGlassWhite: string = _IconMagnifyingGlassWhite;

import _IconMagnifyingGlass from "@images/sprite/ph_magnifying-glass.svg";
export const IconMagnifyingGlass: string = _IconMagnifyingGlass;

import _IconMagnifyingGlassBlue from "@images/sprite/ph_magnifying-glass_blue.svg";
export const IconMagnifyingGlassBlue: string = _IconMagnifyingGlassBlue;

import _IconMagnifyingGlassGrayDarker from "@images/sprite/ph_magnifying-glass_gray-darker.svg";
export const IconMagnifyingGlassGrayDarker: string = _IconMagnifyingGlassGrayDarker;

import _IconMagnifyingGlassGrayLightest from "@images/sprite/ph_magnifying-glass_gray-lightest.svg";
export const IconMagnifyingGlassGrayLightest: string = _IconMagnifyingGlassGrayLightest;

import _IconMailbox from "@images/sprite/ph_mailbox.svg";
export const IconMailbox: string = _IconMailbox;

import _IconMapPinLineFillSmall from "@images/sprite/ph_map-pin-line-fill-small.svg";
export const IconMapPinLineFillSmall: string = _IconMapPinLineFillSmall;

import _IconMapPinLineFill from "@images/sprite/ph_map-pin-line-fill.svg";
export const IconMapPinLineFill: string = _IconMapPinLineFill;

import _IconMapPinLineFillBlack from "@images/sprite/ph_map-pin-line-fill_black.svg";
export const IconMapPinLineFillBlack: string = _IconMapPinLineFillBlack;

import _IconMapPinLineFillBlue from "@images/sprite/ph_map-pin-line-fill_blue.svg";
export const IconMapPinLineFillBlue: string = _IconMapPinLineFillBlue;

import _IconMapPinLineFillGray from "@images/sprite/ph_map-pin-line-fill_gray.svg";
export const IconMapPinLineFillGray: string = _IconMapPinLineFillGray;

import _IconMapPinMagic from "@images/sprite/ph_map-pin-magic.svg";
export const IconMapPinMagic: string = _IconMapPinMagic;

import _IconMapPin from "@images/sprite/ph_map-pin.svg";
export const IconMapPin: string = _IconMapPin;

import _IconMapPinBlack from "@images/sprite/ph_map-pin_black.svg";
export const IconMapPinBlack: string = _IconMapPinBlack;

import _IconMapTrifoldFill from "@images/sprite/ph_map-trifold-fill.svg";
export const IconMapTrifoldFill: string = _IconMapTrifoldFill;

import _IconMap from "@images/sprite/ph_map.svg";
export const IconMap: string = _IconMap;

import _IconMinus from "@images/sprite/ph_minus.svg";
export const IconMinus: string = _IconMinus;

import _IconMoneyFillBlue from "@images/sprite/ph_money-fill_blue.svg";
export const IconMoneyFillBlue: string = _IconMoneyFillBlue;

import _IconMoneyFillGrayDarker from "@images/sprite/ph_money-fill_gray-darker.svg";
export const IconMoneyFillGrayDarker: string = _IconMoneyFillGrayDarker;

import _IconNavigationArrowFill from "@images/sprite/ph_navigation-arrow-fill.svg";
export const IconNavigationArrowFill: string = _IconNavigationArrowFill;

import _IconOutdoorSpace from "@images/sprite/ph_outdoor-space.svg";
export const IconOutdoorSpace: string = _IconOutdoorSpace;

import _IconPantheonFillBlue from "@images/sprite/ph_pantheon-fill_blue.svg";
export const IconPantheonFillBlue: string = _IconPantheonFillBlue;

import _IconPaperClip from "@images/sprite/ph_paper-clip.svg";
export const IconPaperClip: string = _IconPaperClip;

import _IconPaperPlaneTiltFill from "@images/sprite/ph_paper-plane-tilt-fill.svg";
export const IconPaperPlaneTiltFill: string = _IconPaperPlaneTiltFill;

import _IconPaperPlaneTiltFillBlue from "@images/sprite/ph_paper-plane-tilt-fill_blue.svg";
export const IconPaperPlaneTiltFillBlue: string = _IconPaperPlaneTiltFillBlue;

import _IconPaperPlaneTiltFillGrayDark from "@images/sprite/ph_paper-plane-tilt-fill_gray-dark.svg";
export const IconPaperPlaneTiltFillGrayDark: string = _IconPaperPlaneTiltFillGrayDark;

import _IconPaperPlaneTiltFillWhite from "@images/sprite/ph_paper-plane-tilt-fill_white.svg";
export const IconPaperPlaneTiltFillWhite: string = _IconPaperPlaneTiltFillWhite;

import _IconPaperclip from "@images/sprite/ph_paperclip.svg";
export const IconPaperclip: string = _IconPaperclip;

import _IconPen from "@images/sprite/ph_pen.svg";
export const IconPen: string = _IconPen;

import _IconPencilFill from "@images/sprite/ph_pencil-fill.svg";
export const IconPencilFill: string = _IconPencilFill;

import _IconPencilFillBlueDark from "@images/sprite/ph_pencil-fill_blue-dark.svg";
export const IconPencilFillBlueDark: string = _IconPencilFillBlueDark;

import _IconPencilFillGray from "@images/sprite/ph_pencil-fill_gray.svg";
export const IconPencilFillGray: string = _IconPencilFillGray;

import _IconPencilLineFill from "@images/sprite/ph_pencil-line-fill.svg";
export const IconPencilLineFill: string = _IconPencilLineFill;

import _IconPencil from "@images/sprite/ph_pencil.svg";
export const IconPencil: string = _IconPencil;

import _IconPercentBold from "@images/sprite/ph_percent-bold.svg";
export const IconPercentBold: string = _IconPercentBold;

import _IconPercentBoldGrayDarker from "@images/sprite/ph_percent-bold_gray-darker.svg";
export const IconPercentBoldGrayDarker: string = _IconPercentBoldGrayDarker;

import _IconPhoneCall from "@images/sprite/ph_phone-call.svg";
export const IconPhoneCall: string = _IconPhoneCall;

import _IconPhoneCallGrayDarker from "@images/sprite/ph_phone-call_gray-darker.svg";
export const IconPhoneCallGrayDarker: string = _IconPhoneCallGrayDarker;

import _IconPhoneFill from "@images/sprite/ph_phone-fill.svg";
export const IconPhoneFill: string = _IconPhoneFill;

import _IconPhoneFillBlueDark from "@images/sprite/ph_phone-fill_blue-dark.svg";
export const IconPhoneFillBlueDark: string = _IconPhoneFillBlueDark;

import _IconPhoneFillBlue from "@images/sprite/ph_phone-fill_blue.svg";
export const IconPhoneFillBlue: string = _IconPhoneFillBlue;

import _IconPhoneFillWhite from "@images/sprite/ph_phone-fill_white.svg";
export const IconPhoneFillWhite: string = _IconPhoneFillWhite;

import _IconPhoneInbound from "@images/sprite/ph_phone-inbound.svg";
export const IconPhoneInbound: string = _IconPhoneInbound;

import _IconPhoneInboundGrayDarker from "@images/sprite/ph_phone-inbound_gray-darker.svg";
export const IconPhoneInboundGrayDarker: string = _IconPhoneInboundGrayDarker;

import _IconPhotocopier from "@images/sprite/ph_photocopier.svg";
export const IconPhotocopier: string = _IconPhotocopier;

import _IconPlant from "@images/sprite/ph_plant.svg";
export const IconPlant: string = _IconPlant;

import _IconPlusCircleFillBlue from "@images/sprite/ph_plus-circle-fill_blue.svg";
export const IconPlusCircleFillBlue: string = _IconPlusCircleFillBlue;

import _IconPlusCircleFillGray from "@images/sprite/ph_plus-circle-fill_gray.svg";
export const IconPlusCircleFillGray: string = _IconPlusCircleFillGray;

import _IconPlusCircleFillWhite from "@images/sprite/ph_plus-circle-fill_white.svg";
export const IconPlusCircleFillWhite: string = _IconPlusCircleFillWhite;

import _IconPlusCircleBlueDark from "@images/sprite/ph_plus-circle_blue-dark.svg";
export const IconPlusCircleBlueDark: string = _IconPlusCircleBlueDark;

import _IconPlusCircleBlue from "@images/sprite/ph_plus-circle_blue.svg";
export const IconPlusCircleBlue: string = _IconPlusCircleBlue;

import _IconPlusCircleGray from "@images/sprite/ph_plus-circle_gray.svg";
export const IconPlusCircleGray: string = _IconPlusCircleGray;

import _IconPlusFillBlueDark from "@images/sprite/ph_plus-fill_blue-dark.svg";
export const IconPlusFillBlueDark: string = _IconPlusFillBlueDark;

import _IconPlusFillBlue from "@images/sprite/ph_plus-fill_blue.svg";
export const IconPlusFillBlue: string = _IconPlusFillBlue;

import _IconPlusFillGray from "@images/sprite/ph_plus-fill_gray.svg";
export const IconPlusFillGray: string = _IconPlusFillGray;

import _IconPlusFillWhite from "@images/sprite/ph_plus-fill_white.svg";
export const IconPlusFillWhite: string = _IconPlusFillWhite;

import _IconPlus from "@images/sprite/ph_plus.svg";
export const IconPlus: string = _IconPlus;

import _IconPlusWhite from "@images/sprite/ph_plus_white.svg";
export const IconPlusWhite: string = _IconPlusWhite;

import _IconPresentation from "@images/sprite/ph_presentation.svg";
export const IconPresentation: string = _IconPresentation;

import _IconPrinter from "@images/sprite/ph_printer.svg";
export const IconPrinter: string = _IconPrinter;

import _IconProhibitRed from "@images/sprite/ph_prohibit_red.svg";
export const IconProhibitRed: string = _IconProhibitRed;

import _IconQuarterCircle from "@images/sprite/ph_quarter-circle.svg";
export const IconQuarterCircle: string = _IconQuarterCircle;

import _IconQuarterCircleBlue from "@images/sprite/ph_quarter-circle_blue.svg";
export const IconQuarterCircleBlue: string = _IconQuarterCircleBlue;

import _IconQuarterCircleGray from "@images/sprite/ph_quarter-circle_gray.svg";
export const IconQuarterCircleGray: string = _IconQuarterCircleGray;

import _IconQuestionCircle from "@images/sprite/ph_question-circle.svg";
export const IconQuestionCircle: string = _IconQuestionCircle;

import _IconQuestionCircleGrayDarker from "@images/sprite/ph_question-circle_gray-darker.svg";
export const IconQuestionCircleGrayDarker: string = _IconQuestionCircleGrayDarker;

import _IconQuestionFillBlue from "@images/sprite/ph_question-fill_blue.svg";
export const IconQuestionFillBlue: string = _IconQuestionFillBlue;

import _IconQuestionBlue from "@images/sprite/ph_question_blue.svg";
export const IconQuestionBlue: string = _IconQuestionBlue;

import _IconRatpMetro1Big from "@images/sprite/ph_ratp-metro-1-big.svg";
export const IconRatpMetro1Big: string = _IconRatpMetro1Big;

import _IconRatpMetro1Small from "@images/sprite/ph_ratp-metro-1-small.svg";
export const IconRatpMetro1Small: string = _IconRatpMetro1Small;

import _IconRatpMetro10Big from "@images/sprite/ph_ratp-metro-10-big.svg";
export const IconRatpMetro10Big: string = _IconRatpMetro10Big;

import _IconRatpMetro10Small from "@images/sprite/ph_ratp-metro-10-small.svg";
export const IconRatpMetro10Small: string = _IconRatpMetro10Small;

import _IconRatpMetro11Big from "@images/sprite/ph_ratp-metro-11-big.svg";
export const IconRatpMetro11Big: string = _IconRatpMetro11Big;

import _IconRatpMetro11Small from "@images/sprite/ph_ratp-metro-11-small.svg";
export const IconRatpMetro11Small: string = _IconRatpMetro11Small;

import _IconRatpMetro12Big from "@images/sprite/ph_ratp-metro-12-big.svg";
export const IconRatpMetro12Big: string = _IconRatpMetro12Big;

import _IconRatpMetro12Small from "@images/sprite/ph_ratp-metro-12-small.svg";
export const IconRatpMetro12Small: string = _IconRatpMetro12Small;

import _IconRatpMetro13Big from "@images/sprite/ph_ratp-metro-13-big.svg";
export const IconRatpMetro13Big: string = _IconRatpMetro13Big;

import _IconRatpMetro13Small from "@images/sprite/ph_ratp-metro-13-small.svg";
export const IconRatpMetro13Small: string = _IconRatpMetro13Small;

import _IconRatpMetro14Big from "@images/sprite/ph_ratp-metro-14-big.svg";
export const IconRatpMetro14Big: string = _IconRatpMetro14Big;

import _IconRatpMetro14Small from "@images/sprite/ph_ratp-metro-14-small.svg";
export const IconRatpMetro14Small: string = _IconRatpMetro14Small;

import _IconRatpMetro2Big from "@images/sprite/ph_ratp-metro-2-big.svg";
export const IconRatpMetro2Big: string = _IconRatpMetro2Big;

import _IconRatpMetro2Small from "@images/sprite/ph_ratp-metro-2-small.svg";
export const IconRatpMetro2Small: string = _IconRatpMetro2Small;

import _IconRatpMetro3Big from "@images/sprite/ph_ratp-metro-3-big.svg";
export const IconRatpMetro3Big: string = _IconRatpMetro3Big;

import _IconRatpMetro3BisBig from "@images/sprite/ph_ratp-metro-3-bis-big.svg";
export const IconRatpMetro3BisBig: string = _IconRatpMetro3BisBig;

import _IconRatpMetro3BisSmall from "@images/sprite/ph_ratp-metro-3-bis-small.svg";
export const IconRatpMetro3BisSmall: string = _IconRatpMetro3BisSmall;

import _IconRatpMetro3Small from "@images/sprite/ph_ratp-metro-3-small.svg";
export const IconRatpMetro3Small: string = _IconRatpMetro3Small;

import _IconRatpMetro4Big from "@images/sprite/ph_ratp-metro-4-big.svg";
export const IconRatpMetro4Big: string = _IconRatpMetro4Big;

import _IconRatpMetro4Small from "@images/sprite/ph_ratp-metro-4-small.svg";
export const IconRatpMetro4Small: string = _IconRatpMetro4Small;

import _IconRatpMetro5Big from "@images/sprite/ph_ratp-metro-5-big.svg";
export const IconRatpMetro5Big: string = _IconRatpMetro5Big;

import _IconRatpMetro5Small from "@images/sprite/ph_ratp-metro-5-small.svg";
export const IconRatpMetro5Small: string = _IconRatpMetro5Small;

import _IconRatpMetro6Big from "@images/sprite/ph_ratp-metro-6-big.svg";
export const IconRatpMetro6Big: string = _IconRatpMetro6Big;

import _IconRatpMetro6Small from "@images/sprite/ph_ratp-metro-6-small.svg";
export const IconRatpMetro6Small: string = _IconRatpMetro6Small;

import _IconRatpMetro7Big from "@images/sprite/ph_ratp-metro-7-big.svg";
export const IconRatpMetro7Big: string = _IconRatpMetro7Big;

import _IconRatpMetro7BisBig from "@images/sprite/ph_ratp-metro-7-bis-big.svg";
export const IconRatpMetro7BisBig: string = _IconRatpMetro7BisBig;

import _IconRatpMetro7BisSmall from "@images/sprite/ph_ratp-metro-7-bis-small.svg";
export const IconRatpMetro7BisSmall: string = _IconRatpMetro7BisSmall;

import _IconRatpMetro7Small from "@images/sprite/ph_ratp-metro-7-small.svg";
export const IconRatpMetro7Small: string = _IconRatpMetro7Small;

import _IconRatpMetro8Big from "@images/sprite/ph_ratp-metro-8-big.svg";
export const IconRatpMetro8Big: string = _IconRatpMetro8Big;

import _IconRatpMetro8Small from "@images/sprite/ph_ratp-metro-8-small.svg";
export const IconRatpMetro8Small: string = _IconRatpMetro8Small;

import _IconRatpMetro9Big from "@images/sprite/ph_ratp-metro-9-big.svg";
export const IconRatpMetro9Big: string = _IconRatpMetro9Big;

import _IconRatpMetro9Small from "@images/sprite/ph_ratp-metro-9-small.svg";
export const IconRatpMetro9Small: string = _IconRatpMetro9Small;

import _IconRatpMetro from "@images/sprite/ph_ratp-metro.svg";
export const IconRatpMetro: string = _IconRatpMetro;

import _IconRatpRerABig from "@images/sprite/ph_ratp-rer-A-big.svg";
export const IconRatpRerABig: string = _IconRatpRerABig;

import _IconRatpRerASmall from "@images/sprite/ph_ratp-rer-A-small.svg";
export const IconRatpRerASmall: string = _IconRatpRerASmall;

import _IconRatpRerBBig from "@images/sprite/ph_ratp-rer-B-big.svg";
export const IconRatpRerBBig: string = _IconRatpRerBBig;

import _IconRatpRerBSmall from "@images/sprite/ph_ratp-rer-B-small.svg";
export const IconRatpRerBSmall: string = _IconRatpRerBSmall;

import _IconRatpRerCBig from "@images/sprite/ph_ratp-rer-C-big.svg";
export const IconRatpRerCBig: string = _IconRatpRerCBig;

import _IconRatpRerCSmall from "@images/sprite/ph_ratp-rer-C-small.svg";
export const IconRatpRerCSmall: string = _IconRatpRerCSmall;

import _IconRatpRerDBig from "@images/sprite/ph_ratp-rer-D-big.svg";
export const IconRatpRerDBig: string = _IconRatpRerDBig;

import _IconRatpRerDSmall from "@images/sprite/ph_ratp-rer-D-small.svg";
export const IconRatpRerDSmall: string = _IconRatpRerDSmall;

import _IconRatpRerEBig from "@images/sprite/ph_ratp-rer-E-big.svg";
export const IconRatpRerEBig: string = _IconRatpRerEBig;

import _IconRatpRerESmall from "@images/sprite/ph_ratp-rer-E-small.svg";
export const IconRatpRerESmall: string = _IconRatpRerESmall;

import _IconRatpRer from "@images/sprite/ph_ratp-rer.svg";
export const IconRatpRer: string = _IconRatpRer;

import _IconRatpTram1Big from "@images/sprite/ph_ratp-tram-1-big.svg";
export const IconRatpTram1Big: string = _IconRatpTram1Big;

import _IconRatpTram1Small from "@images/sprite/ph_ratp-tram-1-small.svg";
export const IconRatpTram1Small: string = _IconRatpTram1Small;

import _IconRatpTram2Big from "@images/sprite/ph_ratp-tram-2-big.svg";
export const IconRatpTram2Big: string = _IconRatpTram2Big;

import _IconRatpTram2Small from "@images/sprite/ph_ratp-tram-2-small.svg";
export const IconRatpTram2Small: string = _IconRatpTram2Small;

import _IconRatpTram3aBig from "@images/sprite/ph_ratp-tram-3a-big.svg";
export const IconRatpTram3aBig: string = _IconRatpTram3aBig;

import _IconRatpTram3aSmall from "@images/sprite/ph_ratp-tram-3a-small.svg";
export const IconRatpTram3aSmall: string = _IconRatpTram3aSmall;

import _IconRatpTram3bBig from "@images/sprite/ph_ratp-tram-3b-big.svg";
export const IconRatpTram3bBig: string = _IconRatpTram3bBig;

import _IconRatpTram3bSmall from "@images/sprite/ph_ratp-tram-3b-small.svg";
export const IconRatpTram3bSmall: string = _IconRatpTram3bSmall;

import _IconRatpTram4Big from "@images/sprite/ph_ratp-tram-4-big.svg";
export const IconRatpTram4Big: string = _IconRatpTram4Big;

import _IconRatpTram4Small from "@images/sprite/ph_ratp-tram-4-small.svg";
export const IconRatpTram4Small: string = _IconRatpTram4Small;

import _IconRatpTram5Big from "@images/sprite/ph_ratp-tram-5-big.svg";
export const IconRatpTram5Big: string = _IconRatpTram5Big;

import _IconRatpTram5Small from "@images/sprite/ph_ratp-tram-5-small.svg";
export const IconRatpTram5Small: string = _IconRatpTram5Small;

import _IconRatpTram6Big from "@images/sprite/ph_ratp-tram-6-big.svg";
export const IconRatpTram6Big: string = _IconRatpTram6Big;

import _IconRatpTram6Small from "@images/sprite/ph_ratp-tram-6-small.svg";
export const IconRatpTram6Small: string = _IconRatpTram6Small;

import _IconRatpTram7Big from "@images/sprite/ph_ratp-tram-7-big.svg";
export const IconRatpTram7Big: string = _IconRatpTram7Big;

import _IconRatpTram7Small from "@images/sprite/ph_ratp-tram-7-small.svg";
export const IconRatpTram7Small: string = _IconRatpTram7Small;

import _IconRatpTram8Big from "@images/sprite/ph_ratp-tram-8-big.svg";
export const IconRatpTram8Big: string = _IconRatpTram8Big;

import _IconRatpTram8Small from "@images/sprite/ph_ratp-tram-8-small.svg";
export const IconRatpTram8Small: string = _IconRatpTram8Small;

import _IconRatpTram from "@images/sprite/ph_ratp-tram.svg";
export const IconRatpTram: string = _IconRatpTram;

import _IconRatpTransilienHBig from "@images/sprite/ph_ratp-transilien-H-big.svg";
export const IconRatpTransilienHBig: string = _IconRatpTransilienHBig;

import _IconRatpTransilienHSmall from "@images/sprite/ph_ratp-transilien-H-small.svg";
export const IconRatpTransilienHSmall: string = _IconRatpTransilienHSmall;

import _IconRatpTransilienJBig from "@images/sprite/ph_ratp-transilien-J-big.svg";
export const IconRatpTransilienJBig: string = _IconRatpTransilienJBig;

import _IconRatpTransilienJSmall from "@images/sprite/ph_ratp-transilien-J-small.svg";
export const IconRatpTransilienJSmall: string = _IconRatpTransilienJSmall;

import _IconRatpTransilienKBig from "@images/sprite/ph_ratp-transilien-K-big.svg";
export const IconRatpTransilienKBig: string = _IconRatpTransilienKBig;

import _IconRatpTransilienKSmall from "@images/sprite/ph_ratp-transilien-K-small.svg";
export const IconRatpTransilienKSmall: string = _IconRatpTransilienKSmall;

import _IconRatpTransilienLBig from "@images/sprite/ph_ratp-transilien-L-big.svg";
export const IconRatpTransilienLBig: string = _IconRatpTransilienLBig;

import _IconRatpTransilienLSmall from "@images/sprite/ph_ratp-transilien-L-small.svg";
export const IconRatpTransilienLSmall: string = _IconRatpTransilienLSmall;

import _IconRatpTransilienNBig from "@images/sprite/ph_ratp-transilien-N-big.svg";
export const IconRatpTransilienNBig: string = _IconRatpTransilienNBig;

import _IconRatpTransilienNSmall from "@images/sprite/ph_ratp-transilien-N-small.svg";
export const IconRatpTransilienNSmall: string = _IconRatpTransilienNSmall;

import _IconRatpTransilienPBig from "@images/sprite/ph_ratp-transilien-P-big.svg";
export const IconRatpTransilienPBig: string = _IconRatpTransilienPBig;

import _IconRatpTransilienPSmall from "@images/sprite/ph_ratp-transilien-P-small.svg";
export const IconRatpTransilienPSmall: string = _IconRatpTransilienPSmall;

import _IconRatpTransilienRBig from "@images/sprite/ph_ratp-transilien-R-big.svg";
export const IconRatpTransilienRBig: string = _IconRatpTransilienRBig;

import _IconRatpTransilienRSmall from "@images/sprite/ph_ratp-transilien-R-small.svg";
export const IconRatpTransilienRSmall: string = _IconRatpTransilienRSmall;

import _IconRatpTransilienUBig from "@images/sprite/ph_ratp-transilien-U-big.svg";
export const IconRatpTransilienUBig: string = _IconRatpTransilienUBig;

import _IconRatpTransilienUSmall from "@images/sprite/ph_ratp-transilien-U-small.svg";
export const IconRatpTransilienUSmall: string = _IconRatpTransilienUSmall;

import _IconRatpTransilien from "@images/sprite/ph_ratp-transilien.svg";
export const IconRatpTransilien: string = _IconRatpTransilien;

import _IconReceip from "@images/sprite/ph_receip.svg";
export const IconReceip: string = _IconReceip;

import _IconRelaxationSpace from "@images/sprite/ph_relaxation_space.svg";
export const IconRelaxationSpace: string = _IconRelaxationSpace;

import _IconRent from "@images/sprite/ph_rent.svg";
export const IconRent: string = _IconRent;

import _IconRepeat from "@images/sprite/ph_repeat.svg";
export const IconRepeat: string = _IconRepeat;

import _IconRepeatBlack from "@images/sprite/ph_repeat_black.svg";
export const IconRepeatBlack: string = _IconRepeatBlack;

import _IconRj45 from "@images/sprite/ph_rj45.svg";
export const IconRj45: string = _IconRj45;

import _IconRocket from "@images/sprite/ph_rocket.svg";
export const IconRocket: string = _IconRocket;

import _IconRound360 from "@images/sprite/ph_round-360.svg";
export const IconRound360: string = _IconRound360;

import _IconRoundStepUnfilled from "@images/sprite/ph_round-step-unfilled.svg";
export const IconRoundStepUnfilled: string = _IconRoundStepUnfilled;

import _IconRoundStepGreen from "@images/sprite/ph_round-step_green.svg";
export const IconRoundStepGreen: string = _IconRoundStepGreen;

import _IconRoute from "@images/sprite/ph_route.svg";
export const IconRoute: string = _IconRoute;

import _IconRssBoldBlue from "@images/sprite/ph_rss-bold_blue.svg";
export const IconRssBoldBlue: string = _IconRssBoldBlue;

import _IconRulerMagic from "@images/sprite/ph_ruler-magic.svg";
export const IconRulerMagic: string = _IconRulerMagic;

import _IconRuler from "@images/sprite/ph_ruler.svg";
export const IconRuler: string = _IconRuler;

import _IconScanner from "@images/sprite/ph_scanner.svg";
export const IconScanner: string = _IconScanner;

import _IconSearchBlue from "@images/sprite/ph_search_blue.svg";
export const IconSearchBlue: string = _IconSearchBlue;

import _IconServer from "@images/sprite/ph_server.svg";
export const IconServer: string = _IconServer;

import _IconSettings from "@images/sprite/ph_settings.svg";
export const IconSettings: string = _IconSettings;

import _IconShakeHandsSmallBlack from "@images/sprite/ph_shake-hands-small_black.svg";
export const IconShakeHandsSmallBlack: string = _IconShakeHandsSmallBlack;

import _IconShakeHands from "@images/sprite/ph_shake-hands.svg";
export const IconShakeHands: string = _IconShakeHands;

import _IconShakeHandsBlue from "@images/sprite/ph_shake-hands_blue.svg";
export const IconShakeHandsBlue: string = _IconShakeHandsBlue;

import _IconShakeHandsGrayDarker from "@images/sprite/ph_shake-hands_gray-darker.svg";
export const IconShakeHandsGrayDarker: string = _IconShakeHandsGrayDarker;

import _IconShakeHandsGray from "@images/sprite/ph_shake-hands_gray.svg";
export const IconShakeHandsGray: string = _IconShakeHandsGray;

import _IconShakeHandsOrange from "@images/sprite/ph_shake-hands_orange.svg";
export const IconShakeHandsOrange: string = _IconShakeHandsOrange;

import _IconShareNetworkFillBlueDark from "@images/sprite/ph_share-network-fill_blue-dark.svg";
export const IconShareNetworkFillBlueDark: string = _IconShareNetworkFillBlueDark;

import _IconShareNetworkFillBlue from "@images/sprite/ph_share-network-fill_blue.svg";
export const IconShareNetworkFillBlue: string = _IconShareNetworkFillBlue;

import _IconSharedMeetingRoomsPrivate from "@images/sprite/ph_shared-meeting-rooms-private.svg";
export const IconSharedMeetingRoomsPrivate: string = _IconSharedMeetingRoomsPrivate;

import _IconSharedMeetingRooms from "@images/sprite/ph_shared-meeting-rooms.svg";
export const IconSharedMeetingRooms: string = _IconSharedMeetingRooms;

import _IconSharedMeetingRoomsBlack from "@images/sprite/ph_shared-meeting-rooms_black.svg";
export const IconSharedMeetingRoomsBlack: string = _IconSharedMeetingRoomsBlack;

import _IconSharedPhoneboxShared from "@images/sprite/ph_shared-phonebox-shared.svg";
export const IconSharedPhoneboxShared: string = _IconSharedPhoneboxShared;

import _IconSharedPhonebox from "@images/sprite/ph_shared-phonebox.svg";
export const IconSharedPhonebox: string = _IconSharedPhonebox;

import _IconSharedPhoneboxBlack from "@images/sprite/ph_shared-phonebox_black.svg";
export const IconSharedPhoneboxBlack: string = _IconSharedPhoneboxBlack;

import _IconSharedPhoneboxGrayDarker from "@images/sprite/ph_shared-phonebox_gray-darker.svg";
export const IconSharedPhoneboxGrayDarker: string = _IconSharedPhoneboxGrayDarker;

import _IconShieldCheckFillBlack from "@images/sprite/ph_shield-check-fill_black.svg";
export const IconShieldCheckFillBlack: string = _IconShieldCheckFillBlack;

import _IconShieldCheckFillBlue from "@images/sprite/ph_shield-check-fill_blue.svg";
export const IconShieldCheckFillBlue: string = _IconShieldCheckFillBlue;

import _IconShieldCheckFillGreen from "@images/sprite/ph_shield-check-fill_green.svg";
export const IconShieldCheckFillGreen: string = _IconShieldCheckFillGreen;

import _IconShower from "@images/sprite/ph_shower.svg";
export const IconShower: string = _IconShower;

import _IconShuffle from "@images/sprite/ph_shuffle.svg";
export const IconShuffle: string = _IconShuffle;

import _IconSignout from "@images/sprite/ph_signout.svg";
export const IconSignout: string = _IconSignout;

import _IconSlidersFill from "@images/sprite/ph_sliders-fill.svg";
export const IconSlidersFill: string = _IconSlidersFill;

import _IconSlidersFillBlue from "@images/sprite/ph_sliders-fill_blue.svg";
export const IconSlidersFillBlue: string = _IconSlidersFillBlue;

import _IconSmallCaretDownFill from "@images/sprite/ph_small-caret-down-fill.svg";
export const IconSmallCaretDownFill: string = _IconSmallCaretDownFill;

import _IconSmallCaretDownFillBlue from "@images/sprite/ph_small-caret-down-fill_blue.svg";
export const IconSmallCaretDownFillBlue: string = _IconSmallCaretDownFillBlue;

import _IconSmiley from "@images/sprite/ph_smiley.svg";
export const IconSmiley: string = _IconSmiley;

import _IconSnowflake from "@images/sprite/ph_snowflake.svg";
export const IconSnowflake: string = _IconSnowflake;

import _IconSocialRatingGoogle from "@images/sprite/ph_social-rating-google.svg";
export const IconSocialRatingGoogle: string = _IconSocialRatingGoogle;

import _IconSocialRatingStar from "@images/sprite/ph_social-rating-star.svg";
export const IconSocialRatingStar: string = _IconSocialRatingStar;

import _IconSparkleFill from "@images/sprite/ph_sparkle-fill.svg";
export const IconSparkleFill: string = _IconSparkleFill;

import _IconStarBold from "@images/sprite/ph_star-bold.svg";
export const IconStarBold: string = _IconStarBold;

import _IconStarFillSmallGreen from "@images/sprite/ph_star-fill-small_green.svg";
export const IconStarFillSmallGreen: string = _IconStarFillSmallGreen;

import _IconStarFill from "@images/sprite/ph_star-fill.svg";
export const IconStarFill: string = _IconStarFill;

import _IconStarFillBlue from "@images/sprite/ph_star-fill_blue.svg";
export const IconStarFillBlue: string = _IconStarFillBlue;

import _IconStar from "@images/sprite/ph_star.svg";
export const IconStar: string = _IconStar;

import _IconStatus from "@images/sprite/ph_status.svg";
export const IconStatus: string = _IconStatus;

import _IconStatusWhite from "@images/sprite/ph_status_white.svg";
export const IconStatusWhite: string = _IconStatusWhite;

import _IconStorageCorner from "@images/sprite/ph_storage-corner.svg";
export const IconStorageCorner: string = _IconStorageCorner;

import _IconTagFill from "@images/sprite/ph_tag-fill.svg";
export const IconTagFill: string = _IconTagFill;

import _IconTagFillBlack from "@images/sprite/ph_tag-fill_black.svg";
export const IconTagFillBlack: string = _IconTagFillBlack;

import _IconTagFillWhite from "@images/sprite/ph_tag-fill_white.svg";
export const IconTagFillWhite: string = _IconTagFillWhite;

import _IconTagSmallBlue from "@images/sprite/ph_tag-small_blue.svg";
export const IconTagSmallBlue: string = _IconTagSmallBlue;

import _IconTag from "@images/sprite/ph_tag.svg";
export const IconTag: string = _IconTag;

import _IconTeaBag from "@images/sprite/ph_tea-bag.svg";
export const IconTeaBag: string = _IconTeaBag;

import _IconTemplateBlack from "@images/sprite/ph_template_black.svg";
export const IconTemplateBlack: string = _IconTemplateBlack;

import _IconTemplateBlue from "@images/sprite/ph_template_blue.svg";
export const IconTemplateBlue: string = _IconTemplateBlue;

import _IconThreeDotsBold from "@images/sprite/ph_three-dots-bold.svg";
export const IconThreeDotsBold: string = _IconThreeDotsBold;

import _IconThumbUp from "@images/sprite/ph_thumb-up.svg";
export const IconThumbUp: string = _IconThumbUp;

import _IconThumbsDownFill from "@images/sprite/ph_thumbs-down-fill.svg";
export const IconThumbsDownFill: string = _IconThumbsDownFill;

import _IconThumbsUpFill from "@images/sprite/ph_thumbs-up-fill.svg";
export const IconThumbsUpFill: string = _IconThumbsUpFill;

import _IconTickLeftBlueLighter from "@images/sprite/ph_tick-left_blue-lighter.svg";
export const IconTickLeftBlueLighter: string = _IconTickLeftBlueLighter;

import _IconTickRightGrayLight from "@images/sprite/ph_tick-right_gray-light.svg";
export const IconTickRightGrayLight: string = _IconTickRightGrayLight;

import _IconTicketFill from "@images/sprite/ph_ticket-fill.svg";
export const IconTicketFill: string = _IconTicketFill;

import _IconTimerBig from "@images/sprite/ph_timer-big.svg";
export const IconTimerBig: string = _IconTimerBig;

import _IconTimer from "@images/sprite/ph_timer.svg";
export const IconTimer: string = _IconTimer;

import _IconToiletPrivate from "@images/sprite/ph_toilet-private.svg";
export const IconToiletPrivate: string = _IconToiletPrivate;

import _IconTrain from "@images/sprite/ph_train.svg";
export const IconTrain: string = _IconTrain;

import _IconTrashFill from "@images/sprite/ph_trash-fill.svg";
export const IconTrashFill: string = _IconTrashFill;

import _IconTrashFillBlue from "@images/sprite/ph_trash-fill_blue.svg";
export const IconTrashFillBlue: string = _IconTrashFillBlue;

import _IconTrashFillGrayDark from "@images/sprite/ph_trash-fill_gray-dark.svg";
export const IconTrashFillGrayDark: string = _IconTrashFillGrayDark;

import _IconTrashFillRed from "@images/sprite/ph_trash-fill_red.svg";
export const IconTrashFillRed: string = _IconTrashFillRed;

import _IconTrash from "@images/sprite/ph_trash.svg";
export const IconTrash: string = _IconTrash;

import _IconTrendDownFill from "@images/sprite/ph_trend-down-fill.svg";
export const IconTrendDownFill: string = _IconTrendDownFill;

import _IconTrendDownFillGreen from "@images/sprite/ph_trend-down-fill_green.svg";
export const IconTrendDownFillGreen: string = _IconTrendDownFillGreen;

import _IconTrendUp from "@images/sprite/ph_trend-up.svg";
export const IconTrendUp: string = _IconTrendUp;

import _IconTv from "@images/sprite/ph_tv.svg";
export const IconTv: string = _IconTv;

import _IconUploadSimpleSmall from "@images/sprite/ph_upload-simple-small.svg";
export const IconUploadSimpleSmall: string = _IconUploadSimpleSmall;

import _IconUploadSimple from "@images/sprite/ph_upload-simple.svg";
export const IconUploadSimple: string = _IconUploadSimple;

import _IconUploadSimpleBlue from "@images/sprite/ph_upload-simple_blue.svg";
export const IconUploadSimpleBlue: string = _IconUploadSimpleBlue;

import _IconUploadSimpleGrayDarker from "@images/sprite/ph_upload-simple_gray-darker.svg";
export const IconUploadSimpleGrayDarker: string = _IconUploadSimpleGrayDarker;

import _IconUserCircleFill from "@images/sprite/ph_user-circle-fill.svg";
export const IconUserCircleFill: string = _IconUserCircleFill;

import _IconUserCircleFillGrayDarker from "@images/sprite/ph_user-circle-fill_gray-darker.svg";
export const IconUserCircleFillGrayDarker: string = _IconUserCircleFillGrayDarker;

import _IconUserCircle from "@images/sprite/ph_user-circle.svg";
export const IconUserCircle: string = _IconUserCircle;

import _IconUserFillYellow from "@images/sprite/ph_user-fill_yellow.svg";
export const IconUserFillYellow: string = _IconUserFillYellow;

import _IconUserPlus from "@images/sprite/ph_user-plus.svg";
export const IconUserPlus: string = _IconUserPlus;

import _IconUserBlue from "@images/sprite/ph_user_blue.svg";
export const IconUserBlue: string = _IconUserBlue;

import _IconUsersFillGrayDarker from "@images/sprite/ph_users-fill_gray-darker.svg";
export const IconUsersFillGrayDarker: string = _IconUsersFillGrayDarker;

import _IconUsersPlus from "@images/sprite/ph_users-plus.svg";
export const IconUsersPlus: string = _IconUsersPlus;

import _IconUsersSmallBlue from "@images/sprite/ph_users-small_blue.svg";
export const IconUsersSmallBlue: string = _IconUsersSmallBlue;

import _IconUsers from "@images/sprite/ph_users.svg";
export const IconUsers: string = _IconUsers;

import _IconUsersBlue from "@images/sprite/ph_users_blue.svg";
export const IconUsersBlue: string = _IconUsersBlue;

import _IconUsersGrayDarker from "@images/sprite/ph_users_gray-darker.svg";
export const IconUsersGrayDarker: string = _IconUsersGrayDarker;

import _IconUsersGray from "@images/sprite/ph_users_gray.svg";
export const IconUsersGray: string = _IconUsersGray;

import _IconVacantSpace from "@images/sprite/ph_vacant-space.svg";
export const IconVacantSpace: string = _IconVacantSpace;

import _IconVideoProjector from "@images/sprite/ph_video-projector.svg";
export const IconVideoProjector: string = _IconVideoProjector;

import _IconVisitDone from "@images/sprite/ph_visit-done.svg";
export const IconVisitDone: string = _IconVisitDone;

import _IconVisitDoneGray from "@images/sprite/ph_visit-done_gray.svg";
export const IconVisitDoneGray: string = _IconVisitDoneGray;

import _IconVisitDoneRed from "@images/sprite/ph_visit-done_red.svg";
export const IconVisitDoneRed: string = _IconVisitDoneRed;

import _IconVisitPassed from "@images/sprite/ph_visit-passed.svg";
export const IconVisitPassed: string = _IconVisitPassed;

import _IconVisitPassedBlack from "@images/sprite/ph_visit-passed_black.svg";
export const IconVisitPassedBlack: string = _IconVisitPassedBlack;

import _IconVisitPassedBlue from "@images/sprite/ph_visit-passed_blue.svg";
export const IconVisitPassedBlue: string = _IconVisitPassedBlue;

import _IconVisitPassedGreen from "@images/sprite/ph_visit-passed_green.svg";
export const IconVisitPassedGreen: string = _IconVisitPassedGreen;

import _IconVisitPlannedBigBlue from "@images/sprite/ph_visit-planned-big_blue.svg";
export const IconVisitPlannedBigBlue: string = _IconVisitPlannedBigBlue;

import _IconVisitPlanned from "@images/sprite/ph_visit-planned.svg";
export const IconVisitPlanned: string = _IconVisitPlanned;

import _IconVisitPlannedBlue from "@images/sprite/ph_visit-planned_blue.svg";
export const IconVisitPlannedBlue: string = _IconVisitPlannedBlue;

import _IconVisitPlannedGrayDark from "@images/sprite/ph_visit-planned_gray-dark.svg";
export const IconVisitPlannedGrayDark: string = _IconVisitPlannedGrayDark;

import _IconVisitPlannedWhite from "@images/sprite/ph_visit-planned_white.svg";
export const IconVisitPlannedWhite: string = _IconVisitPlannedWhite;

import _IconVisitQuestion from "@images/sprite/ph_visit-question.svg";
export const IconVisitQuestion: string = _IconVisitQuestion;

import _IconVisitScheduled from "@images/sprite/ph_visit-scheduled.svg";
export const IconVisitScheduled: string = _IconVisitScheduled;

import _IconVisitToday from "@images/sprite/ph_visit-today.svg";
export const IconVisitToday: string = _IconVisitToday;

import _IconWaitingArea from "@images/sprite/ph_waiting_area.svg";
export const IconWaitingArea: string = _IconWaitingArea;

import _IconWarningFillSmallYellow from "@images/sprite/ph_warning-fill-small_yellow.svg";
export const IconWarningFillSmallYellow: string = _IconWarningFillSmallYellow;

import _IconWarningFill from "@images/sprite/ph_warning-fill.svg";
export const IconWarningFill: string = _IconWarningFill;

import _IconWarningFillRed from "@images/sprite/ph_warning-fill_red.svg";
export const IconWarningFillRed: string = _IconWarningFillRed;

import _IconWarningFillWhite from "@images/sprite/ph_warning-fill_white.svg";
export const IconWarningFillWhite: string = _IconWarningFillWhite;

import _IconWarningFillYellow from "@images/sprite/ph_warning-fill_yellow.svg";
export const IconWarningFillYellow: string = _IconWarningFillYellow;

import _IconWhatsapp from "@images/sprite/ph_whatsapp.svg";
export const IconWhatsapp: string = _IconWhatsapp;

import _IconWhatsappGrayDarker from "@images/sprite/ph_whatsapp_gray-darker.svg";
export const IconWhatsappGrayDarker: string = _IconWhatsappGrayDarker;

import _IconWhatsappGreen from "@images/sprite/ph_whatsapp_green.svg";
export const IconWhatsappGreen: string = _IconWhatsappGreen;

import _IconWheelchairFill from "@images/sprite/ph_wheelchair-fill.svg";
export const IconWheelchairFill: string = _IconWheelchairFill;

import _IconWifi from "@images/sprite/ph_wifi.svg";
export const IconWifi: string = _IconWifi;

import _IconXBold from "@images/sprite/ph_x-bold.svg";
export const IconXBold: string = _IconXBold;

import _IconXCircleFillSmallRed from "@images/sprite/ph_x-circle-fill-small_red.svg";
export const IconXCircleFillSmallRed: string = _IconXCircleFillSmallRed;

import _IconXCircleFill from "@images/sprite/ph_x-circle-fill.svg";
export const IconXCircleFill: string = _IconXCircleFill;

import _IconXCircleFillGrayDark from "@images/sprite/ph_x-circle-fill_gray-dark.svg";
export const IconXCircleFillGrayDark: string = _IconXCircleFillGrayDark;

import _IconXCircleFillRed from "@images/sprite/ph_x-circle-fill_red.svg";
export const IconXCircleFillRed: string = _IconXCircleFillRed;

import _IconXSmall from "@images/sprite/ph_x-small.svg";
export const IconXSmall: string = _IconXSmall;

import _IconXSmallRed from "@images/sprite/ph_x-small_red.svg";
export const IconXSmallRed: string = _IconXSmallRed;

import _IconX from "@images/sprite/ph_x.svg";
export const IconX: string = _IconX;

import _IconXGrayDarker from "@images/sprite/ph_x_gray-darker.svg";
export const IconXGrayDarker: string = _IconXGrayDarker;

import _IconXRed from "@images/sprite/ph_x_red.svg";
export const IconXRed: string = _IconXRed;

import _IconXWhite from "@images/sprite/ph_x_white.svg";
export const IconXWhite: string = _IconXWhite;
